<template>
  <div :class="`${prefixClass}__wrap`">
    <t-select
      v-if="data && data.length"
      v-model="tmpItem"
      :disabled="disabled"
      :filterable="filterable"
      :size="size"
      :clearable="clearable"
      :class="`${prefixClass}__caspanel`"
      @on-select-selected-with-index="$_onSelectSelectedWithIndex"
    >
      <t-option
        v-for="(item, index) in data"
        :key="item.value + index"
        :value="item.value"
        :disabled="item.disabled"
      >
        {{ item.label }}
      </t-option>
    </t-select>
    <span v-show="tmpItem.loading" :class="`${prefixClass}--loading`"><t-icon icon="loading" :class="`${PREFIX_ICON_CLASS}loading`"></t-icon>{{ loading }}</span>
    <t-caspanel
      v-show="!tmpItem.loading"
      v-if="sublist && sublist.length"
      :prefix-class="prefixClass"
      :data="sublist"
      :disabled="disabled"
      :size="size"
      :clearable="clearable"
      :filterable="filterable"
      :change-on-select="changeOnSelect"
    ></t-caspanel>
    <div class="clearfix"></div>
  </div>
</template>
<script>
import TSelect from '../select/select.vue'
import Emitter from '../../mixins/emitter'
import { findComponentUpward } from '../../utils/assist'
import locale from '../../mixins/locale'
import { t } from '../../locale'
import { PREFIX_ICON_CLASS, CLASS_MAIN, PREFIX_CLASS } from '../../utils/constants'
export default {
  name: 'TCaspanel',
  components: { TSelect },
  mixins: [locale, Emitter],
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    size: {
      type: String,
      default: ''
    },
    clearable: Boolean,
    disabled: Boolean,
    changeOnSelect: Boolean,
    prefixClass: {
      type: String,
      default: ''
    },
    filterable: Boolean
  },
  data() {
    return {
      PREFIX_ICON_CLASS: PREFIX_ICON_CLASS,
      CLASS_MAIN: CLASS_MAIN,
      PREFIX_CLASS: PREFIX_CLASS,
      loading: t('t.cascader.loading'),
      tmpItem: {},
      result: [],
      sublist: [],
      tmpSelectedItem: '', // 用于存储上一次选中的value
      level: 1
    }
  },
  watch: {
    data() {
      this.sublist = []
    }
  },
  mounted() {
    this.$on('on-find-selected', params => {
      const val = params.value
      let value = [...val]
      for (let i = 0; i < value.length; i++) {
        for (let j = 0; j < this.data.length; j++) {
          if (value[i] === this.data[j].value) {
            this.$_setInitVal(this.data[j], true)
            value.splice(0, 1)
            this.$nextTick(() => {
              this.broadcast('TCaspanel', 'on-find-selected', {
                value: value
              })
            })
            return false
          }
        }
      }
    })
    this.$on('on-clear', () => {
      this.sublist = []
      this.tmpItem = {}
    })
  },
  methods: {
    $_setInitVal(item, fromInit = false) {
      if (item.disabled) return
      const backItem = this.$_getBaseItem(item)
      this.tmpItem = backItem
      if (item.loading !== undefined && !item.children.length) {
        const cascader = findComponentUpward(this, 'TCascader')
        if (cascader && cascader.loader) {
          this.tmpItem.loading = true
          cascader.loader(item, () => {
            this.tmpItem.loading = false
            this.$_handleTriggerItem(item)
          })
          return
        }
      }
      this.changeResult(item, backItem, fromInit)
    },
    async $_onSelectSelectedWithIndex(index) {
      let panel = null
      await this.$_handleTriggerItem(this.data[index])
      this.$nextTick(() => {
        panel = this.$children.find(item => {
          return item && item.$vnode && item.$vnode.tag && /TCaspanel/ig.test(item.$vnode.tag)
        })
        if (panel) {
          panel.level = this.level + 1
        }
      })
      // this.$_handleTriggerItem(this.data[index])
    },
    $_handleTriggerItem(item, fromInit = false) {
      if (item.disabled) return Promise.resolve()
      const backItem = this.$_getBaseItem(item)
      this.tmpItem = backItem

      if (item.loading !== undefined && !item.children.length) {
        const cascader = findComponentUpward(this, 'TCascader')
        if (cascader && cascader.loader) {
          this.tmpItem.loading = true
          return new Promise((resolve, reject) => {
            cascader.loader(item, async () => {
              this.tmpItem.loading = false
              await this.$_handleTriggerItem(item)
              resolve()
            })
          })
        }
      }
      if (this.changeOnSelect && this.tmpItem.value === this.tmpSelectedItem) return
      this.changeResult(item, backItem, fromInit)
      // 设置上次选中的值
      this.tmpSelectedItem = this.tmpItem.value
      return Promise.resolve()
    },
    changeResult(item, backItem, fromInit) {
      // 向上递归，设置临时选中值（并非真实选中）
      this.$_emitUpdate([backItem])
      let lastValue = false
      if (item.children && item.children.length) {
        this.sublist = item.children
      } else {
        this.sublist = []
        lastValue = true
      }
      this.dispatch('TCascader', 'on-result-change', {
        lastValue: lastValue,
        changeOnSelect: this.changeOnSelect,
        fromInit: fromInit
      })
    },
    updateResult(item) {
      this.result = [this.tmpItem].concat(item)
      this.$_emitUpdate(this.result)
    },
    $_getBaseItem(item) {
      let backItem = Object.assign({}, item)
      if (backItem.children) {
        delete backItem.children
      }

      return backItem
    },
    $_emitUpdate(result) {
      this.$parent && this.$parent.updateResult(result)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/cascader/caspanel.vue